import { MarketingEntryPoint } from "@redotech/redo-model/advanced-flow/schemas/marketing/marketing";
import { BrandKit } from "@redotech/redo-model/brand-kit";
import { getSignupFormSchema } from "@redotech/redo-model/marketing/schemas/get-signup-form-schema";
import { submitSignupFormStepSchema as submitSignupFormStep } from "@redotech/redo-model/marketing/schemas/submit-signup-form-step-schema";
import { logSignupFormAnalyticsSchema as logSignupFormAnalytics } from "@redotech/redo-model/marketing/schemas/view-signup-form-schema";
import { SignupForm } from "@redotech/redo-model/signup-form-schema";
import { ExitIntentPopupFormInstance } from "@redotech/redo-web/marketing/signup-form/exit-intent-popup-instance";
import { RedoMarketingPopupFormInstance } from "@redotech/redo-web/marketing/signup-form/popup-form-instance";
import { SignupFormClient } from "@redotech/redo-web/marketing/signup-form/types";
import { getCustomFieldOptions } from "@redotech/shopify-sdk/rpc/schema/marketing-embedded-form/get-custom-field-options";
import { memo, useContext, useMemo } from "react";
import { RedoShopifyRpcClientContext } from "../../../client/redo-shopify-rpc-client";

export const SignupFormInstanceWrapper = memo(
  function SignupFormInstanceWrapper({
    brandKit,
    utmParams,
    forceId,
    forceForm,
  }: {
    brandKit: BrandKit;
    utmParams: string;
    forceId?: string;
    forceForm?: SignupForm;
  }) {
    const rpcClient = useContext(RedoShopifyRpcClientContext);
    const shopifyCustomerId = useMemo(
      () =>
        (
          globalThis as any
        ).ShopifyAnalytics?.meta?.page?.customerId?.toString() ?? null,
      [],
    );

    const client: SignupFormClient | undefined = useMemo(() => {
      if (!rpcClient) {
        return;
      }
      return {
        getSignupForm: async (params, options) =>
          rpcClient(getSignupFormSchema, params, options),
        getCustomFieldOptions: async (params) =>
          rpcClient(getCustomFieldOptions, params),
        logSignupFormAnalytics: async (params) =>
          rpcClient(logSignupFormAnalytics, params),
        submitSignupFormStep: async (params) =>
          rpcClient(submitSignupFormStep, params),
      } satisfies SignupFormClient;
    }, [rpcClient]);

    return (
      <>
        <RedoMarketingPopupFormInstance
          brandKit={brandKit}
          entryPoint={MarketingEntryPoint.SIGNUP_FORM}
          forceForm={forceForm}
          forceId={forceId}
          rpcClient={client}
          shopifyCustomerId={shopifyCustomerId}
          site="marketing"
          utmParams={utmParams}
        />
        {/* Exit intent popup is separate and only queries for forms with exit intent enabled */}
        <ExitIntentPopupFormInstance
          brandKit={brandKit}
          entryPoint={MarketingEntryPoint.SIGNUP_FORM}
          rpcClient={client}
          shopifyCustomerId={shopifyCustomerId}
          site="marketing"
          utmParams={utmParams}
        />
      </>
    );
  },
);
